/// <reference path="../../app.definition.ts" />

import angular from 'angular';
import * as _ from 'lodash';
import * as Papa from '@libs/papaParse/papaParse.min.js';
import { saveAs } from 'file-saver';

declare function sendReportDataIos(filename: string, csvData: string): void;
declare function sendReportDataAndroid(filename: string, csvData: string): void;

export interface ITableService {

}

export class TableService implements ITableService {
    static $inject = ["$filter", "UtilityService", "$timeout"];
    constructor(
        $filter,
        UtilityService,
        $timeout
    ) {

    }

    exportToCSV = (data, exportColumns, columnConfig, sortedBy) => {
        const jQuery = (window as any).jQuery;
        let exportConfig = _.cloneDeep(exportColumns);
        if (!data) {
            return;
        }

        let hiddenCols = columnConfig.filter(col => col.isHidden);
        hiddenCols.forEach(col => {
            _.remove(exportConfig.columns, (c) => (c.name == col.field || c.name == col.valueFieldName));
        });

        var config = {
            quotes: [true, true],
            newline: "\n",
            header: true
        };
        var filename = exportConfig.fileName + "-" + new Date().getTime() + ".csv";
        var cData = _.cloneDeep(data);
        var isDesc = (sortedBy.indexOf('-') == 0);
        if (isDesc) {
            sortedBy = sortedBy.substr(1, sortedBy.length - 1);
        }

        var mapping = _.reduce(columnConfig, (ac, obj) => {
            let col = exportConfig.columns.find(c => c['name'] == obj.field || c['name'] == obj.valueFieldName || (!!obj.sorting && c['name'] == obj.sorting.field));
            //Use columnConfig label, but if label is available in exportConfig then use that
            let lbl = obj.label;
            (!!col && !!col['label']) && (lbl = col['label']);
            ac[obj.field] = lbl;
            ac[obj.valueFieldName] = lbl;
            !!obj.sorting && (ac[obj.sorting.field] = lbl);
            return ac;
        }, {});

        // Apply Column labels
        if (Array.isArray(exportConfig.columns)) {
            cData = _.map(data, (d) => {
                var obj = {};
                exportConfig.columns.forEach(col => {
                    let val = d[col['name']];
                    if (!!col.transform) {
                        val = eval(col.transform);
                    }
                    //Text with length greater than 32000 would cause issues while displaying in
                    // ms excel, hence clipping it.
                    if (val.length > 32000) {
                        obj[mapping[col['name']]] = "[Truncated] " + val.slice(0, 32000);
                    } else {
                        obj[mapping[col['name']]] = val;
                    }
                });
                return obj;
            });
        }
        //apply sorting
        if (cData.length > 0) {
            let sortArr = [];
            let type = typeof cData[0][mapping[sortedBy]];
            var arr = [];
            if (type == "string") {
                sortArr = [u => u[mapping[sortedBy]].toLowerCase()];
                arr = _.filter(cData, (d) => { return typeof d[mapping[sortedBy]] == "number" });
            } else if (type == "number") {
                sortArr = [mapping[sortedBy]];
                arr = _.filter(cData, (d) => { return typeof d[mapping[sortedBy]] == "string" });
            } else if (type == "object" && cData[0][mapping[sortedBy]] instanceof Date) {
                sortArr = [u => u[mapping[sortedBy]].getTime()];
            }
            if (arr.length == 0) {
                cData = _.orderBy(cData, sortArr, [isDesc ? 'desc' : 'asc']);
            } else {
                cData = cData.sort((a, b) => a[mapping[sortedBy]].toString().localeCompare(b[mapping[sortedBy]].toString(), undefined, { numeric: true }));
                if (isDesc) {
                    cData = cData.reverse();
                }
            }
        }

        var csvData = Papa.unparse({
            data: cData
        }, config);

        var blob = new Blob([csvData], {
            type: 'text/csv'
        });
        let loc = window.location.href;

        if (loc.includes('webview')) {
            try {
                sendReportDataIos(filename, csvData);
            } catch (e) {
                console.log("Error in sendReportDataIos: ", e);
            }
        } else if (loc.includes('android')) {
            try {
                sendReportDataAndroid(filename, csvData);
            } catch (e) {
                console.log("Error in sendReportDataAndroid: ", e);
            }
        } else {
            try {
                saveAs(blob, filename);
            } catch (e) {
                (window.navigator as any).msSaveBlob(blob, filename);
            }
        }
    }
}

angular.module('eCareVault.common.services')
    .service('TableService', TableService);
